<div class="container-fluid">
    <div class="col-12 flex">
        <div class="col-3 p-0">
            <div class="col-12 p-0">
                <div class="flex ui-inputgroup search-box">
                    <div style="width:50%">
                        <p-dropdown [style]="{'width':'100%','border-radius':'5px 0px 0px 5px'}" placeholder="Choose Search" [options]="fieldsForSearch"
                            [(ngModel)]="selectedSearchField">
                        </p-dropdown>
                    </div>
                    <input pInputText  [(ngModel)]="searchValue" size="17"
                        (keydown.enter)="searchKeyword()" />
                    <button pButton icon="fa fa-search" [disabled]="!searchValue || searchValue?.trim() == ''"
                        (click)="searchKeyword()">
                    </button>
                </div>
            </div>
            <div class="col-12 p-0 mt-4">
                <div class="table-decorator">
                    <p-table #orderTable [value]="orders" selectionMode="none" [columns]="orderTableCols" [scrollable]="true" scrollHeight="30vh"
                        [loading]="orderTableLoading" dataKey="orderNumber">
                        <ng-template pTemplate="caption">
                            <div class="flex justify-content-between">
                                <input pInputText placeholder="Global Filter" (input)="orderTable.filterGlobal($event.target.value, 'contains')" class="bg-white p-0 float-left search-width">
                                <label class="text-center m-0">Orders</label>
                                <em role="button" class="fa fa-refresh float-right" (click)="reloadOrders()"></em>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th scope="col" [style.width]="column.width" *ngFor="let column of columns">{{column.header}}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr [ngStyle]="{'background-color': (!rowData.extraction || !rowData.rgcAvailable) ? '#eef2f5':'', 'color': rowData.express ? 'red' : ''}">
                                <ng-container *ngFor="let col of columns">
                                    <td *ngIf="col.field == 'orderAdder'" class="text-center p-0" [style.width]="col.width">
                                        <button pButton icon="fa fa-plus-circle" [hidden]="hideOrderAdder(rowData)" (click)="addOrderSamplesToPlate(rowData)"></button>
                                    </td>
                                    <td *ngIf="col.field == 'orderNumber'" class="text-break" [style.width]="col.width" >
                                        {{rowData[col.field]}}
                                        <label *ngIf="rowData?.gxp" class="m-0 font-weight-bold text-danger " >GxP</label>
                                    </td>
                                    <td *ngIf="col.field != 'orderNumber' && col.field != 'orderAdder'" class="text-break" [style.width]="col.width" >
                                        {{rowData[col.field]}}
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>


            <div class="col-12 flex p-0 m-2">
                <div class="col-11 flex p-0 pr-5 font-bold justify-content-end" *ngIf="!showExtractionCompletedBatches"><label class="show-comleted-label font-weight-bold">Show Completed Batches</label></div>
                <div *ngIf="showExtractionCompletedBatches"  class="col-4 p-0">
                    <p-calendar [style]="{'width':'100%'}" hourFormat="24" dateFormat="dd.MM.yy" class="datePicker1" [(ngModel)]="scheduledFromDate" (onSelect)="getCompletedTableData()"></p-calendar>
                </div>
                <div *ngIf="showExtractionCompletedBatches"  class="col-4 p-0">
                    <p-calendar  [style]="{'width':'100%'}" hourFormat="24" dateFormat="dd.MM.yy" class="datePicker2" [(ngModel)]="scheduledToDate" (onSelect)="getCompletedTableData()"></p-calendar>
                </div>
                <div [ngClass]="showExtractionCompletedBatches ? 'col-4 p-0 toggler' : 'col-1 p-0'">
                    <p-inputSwitch [style]="{'float': 'right'}" [(ngModel)]="showExtractionCompletedBatches" (onChange)="getCompletedTableData()"></p-inputSwitch>
                </div>
            </div>
            <div class="col-12 p-0 table-decorator">
                <p-table #batchTable [value]="batches" selectionMode="single" [columns]="batchTableCols" scrollable="true" scrollHeight="30vh"
                    (onRowUnselect)="clearPlate()" (onRowSelect)="searchBatch($event.data.batchId, 'batchId')" [loading]="batchTableLoading"
                    [(selection)]="selectedBatch" dataKey="batchId">
                    <ng-template pTemplate="caption">
                        <div class="flex justify-content-between">
                            <input type="text" pInputText placeholder="Global Filter" (input)="batchTable.filterGlobal($event.target.value, 'contains')" class="bg-white p-0 float-left search-width">
                            <label class="text-center m-0">Batches</label>
                            <em role="button" class="fa fa-refresh float-right" (click)="reloadBatches()"></em>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th scope="col" [style.width]="column.width"  *ngFor="let column of columns">{{column.header}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr [pSelectableRow]="rowData">
                            <ng-container *ngFor="let col of columns">
                                <td *ngIf="col.field == 'batchId'" [style.width]="col.width" class="text-break">
                                    {{rowData['initials']}} {{rowData[col.field]}}
                                    <label *ngIf="rowData?.gxp" class="m-0 font-weight-bold text-danger " >GxP</label>
                                </td>
                                <td *ngIf="col.field == 'count'" [style.width]="col.width" class="text-break">
                                    {{rowData['sampleBarcodes'] ? rowData['sampleBarcodes'].length : 0}}
                                </td>
                                <td *ngIf="col.field == 'status'" [style.width]="col.width" class="text-break status-font">
                                    {{rowData['status']}}
                                </td>
                            </ng-container>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>

        <div class="col-9">
            <table aria-describedby="Batch Table" class="batch-table">
                <thead id="processingTableHeader">
                    <tr>
                        <th scope="col">Create Extraction Batch</th>
                        <th scope="col">Extraction</th>
                        <th scope="col">Comments</th>
                    </tr>
                </thead>
                <tbody class="processingTableBody">
                    <tr>
                        <td>
                            <div class="ui-inputgroup search-box batch-input">
                                <button pButton class="labelButton" label="Batch ID"></button>
                                <input pInputText [value]="selectedBatch?.initials" class="initials"
                                    readonly />
                                 &nbsp;—&nbsp;
                                <input pInputText class="batchid" [value]="selectedBatch?.batchId"
                                readonly />
                                <span>
                                    <label *ngIf="selectedBatch?.gxp" class="font-bold ml-3 text-xl text-danger" >GxP</label>
                                </span>
                            </div>
                            <div class="col-12 flex">
                                <div class="col-8">
                                    <button pButton icon="pi pi-plus" label="New Batch" (click)="newBatchOverlay.toggle($event)"
                                         class="action-button start-button"></button>
                                    <p-overlayPanel [style]="{'width':'20rem', 'background-color':'whitesmoke'}" #newBatchOverlay appendTo="body"  [baseZIndex]="10000000">
                                        <ng-template pTemplate>
                                            <div class="flex">
                                                <div class="ui-inputgroup ml-2">
                                                    <button pButton class="labelButton" label="Initials"
                                                       ></button>
                                                    <input pInputText class="overlay-input" [(ngModel)]="newInitials" />
                                                </div>
                                                <button pButton label="Create" class="ml-5 p-2 border-round" [disabled]="!newInitials || newInitials.trim() == ''" (click)="createNewBatch(newBatchOverlay)"></button>
                                            </div>
                                        </ng-template>
                                    </p-overlayPanel>
                                </div>
                                <div class="col-4 sibling">
                                    {{selectedBatch?.creationDate | date: dateTimeFormat}} <br />
                                    {{selectedBatch?.creationPUID}}
                                </div>
                            </div>
                            <div class="ui-inputgroup col-12 flex p-0">
                                <button pButton class="labelButton table-row" type="button"
                                    label="Extraction Kit"></button>
                                <p-dropdown [style]="{'width':'10rem'}" [options]="extractionKits" [(ngModel)]="selectedExtractionKit" [disabled]="selectedBatch?.status != 'BATCH_CREATED'"
                                    placeholder="Select Kit"></p-dropdown>
                            </div>
                            <div class="col-12 flex parent">
                                <div class="col-8 child">
                                    <button pButton label="Complete Batch" (click)="completeBatch()"
                                        [disabled]="!(selectedBatch?.status == 'BATCH_CREATED' && selectedExtractionKit && !scanOperationStarted && selectedBatch?.sampleDetails?.length > 0)" class="action-button complete-button"></button>
                                </div>
                                <div class="col-4 sibling">
                                    {{selectedBatch?.completionDate | date: dateTimeFormat}} <br />
                                    {{selectedBatch?.completionPUID}}
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="col-12 flex parent">
                                <div class="col-8 child">
                                    <button pButton label="Start Extraction" (click)="startExtraction()"
                                        [disabled]="selectedBatch?.status != 'BATCH_COMPLETE'" class="action-button start-button"></button>
                                </div>
                                <div class="col-4 sibling">
                                    {{selectedBatch?.startExtractionDate | date: dateTimeFormat}} <br />
                                    {{selectedBatch?.startExtractionPUID}}
                                </div>
                            </div>
                            <div class="col-12 flex parent">
                                <div class="col-8 child">
                                    <button pButton label="Lot" (click)="showKitLotPopUp()"
                                        [disabled]="selectedBatch?.status != 'EXTRACTION_START'" class="action-button"></button>
                                </div>

                            </div>
                            <div class="col-12 flex parent">
                                <div class="col-8 child">
                                    <button pButton label="Complete Extraction"
                                        (click)="completeExtraction()" [disabled]="!(selectedBatch?.status == 'EXTRACTION_START' && atLeastOneLotNumberFilled) "
                                        class="action-button complete-button"></button>
                                </div>
                                <div class="col-4 sibling">
                                    {{selectedBatch?.completeExtractionDate | date: dateTimeFormat}} <br />
                                    {{selectedBatch?.completeExtractionPUID}}
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="col-12">
                                <div class="ui-inputgroup">
                                    <button pButton class="labelButton comment-labels" label="Plate Comment"></button>
                                    <textarea class="comment-textarea" pInputTextarea rows="2" cols="30" [ngModel]="selectedBatch?.comments" (ngModelChange)="selectedBatch.comments=$event" (blur)="saveBatch()"
                                        [disabled]="!selectedBatch" ></textarea>
                                </div>

                                <div class="flex ui-inputgroup mt-3">
                                    <button pButton class="labelButton comment-labels" label="Order Comment"></button>
                                    <textarea pInputTextarea rows="2" cols="30" (click)="toggleCommentOverlay($event, commentOverlay)" [innerHTML]="getFirstOrderComment()"
                                        readonly  style=" width: 41%; border: 1px solid black; max-height: 4rem; overflow: hidden; text-overflow: ellipsis;  white-space: normal; display: -webkit-box !important; -webkit-line-clamp: 3; -webkit-box-orient: vertical;"></textarea>
                                    <p-overlayPanel  [style]="{'width':'19rem', 'max-height': '35rem', 'overflow-y':'auto'}" #commentOverlay appendTo="body" [dismissable]="true" [baseZIndex]="10000000">
                                        <ng-template pTemplate>
                                            <div *ngFor="let key of orderCommentsMap.keys()">
                                                <p-fieldset [style]="{'margin-bottom':'10px'}" legend="{{key}}"><p [innerHTML]="orderCommentsMap.get(key)"></p></p-fieldset>
                                            </div>
                                        </ng-template>
                                    </p-overlayPanel>
                                </div>
                            </div>
                        </td>
                    </tr>

                </tbody>
            </table>
            <div class="col-12 tableDiv">
                <p-confirmDialog class="confirm-message"></p-confirmDialog>
                <div class="col-12 flex p-0 mb-1 mt-1 scanner-div">
                    <div class="col-3">
                        <button class="current-position-cell">
                            <div class="current-position-headder">
                                {{currentPosition}}
                            </div>
                        </button>
                    </div>
                    <div class="col-3">
                        <p class="m-0 font-bold">Scan Barcode:</p>
                        <input pInputText type="text" class="barcode-scan-class p-1" id="barcode-scan" [(ngModel)]="scannedBarcode" (keydown.enter)="scanSamples()" [disabled]="scanningDisabled()">
                    </div>
                    <div class="col-3">
                        <p class="m-0 font-bold">Previously scanned:</p>
                        <input pInputText type="text" class="prev-barcode p-1" [value]="previousScannedBarcode" readonly>
                    </div>
                    <div class="col-3 font-bold toggle-button">
                        <p-toggleButton [(ngModel)]="verticalOrientation" onLabel="A1 → H1" offLabel="A1 → A12" [style]="{'width': '50%', 'background-color':'#007AD9','height':'2.5rem'}" [disabled]="!selectedBatch"></p-toggleButton>
                    </div>
                </div>
                <table class="scanTable" aria-describedby="View Plates" class="table">
                    <thead>
                        <tr>
                            <th class="border-0" scope="col"></th>
                            <th class="scan-table-col-header" scope="col"
                                *ngFor="let col of columnHeaders; let k = index">
                                {{col}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of rowHeaders;">
                            <td class="scan-table-row-header p-3">{{row}}</td>
                            <td *ngFor="let col of columnHeaders;" class="border-0 p-0 text-center">
                                <button class="cellviewsold" (click)="cellClickHandler(row, col, stepCommentOverlay, $event)" [style]="getBorderColorStyle(row, col)"
                                    [pTooltip]="getSampleDetails(row, col)" [tooltipDisabled]="isPositionPopulated(row, col)">
                                    <div class="col-12 flex p-0">

                                        <div class="8 p-0">
                                            <div class="sampleInfoHeader">
                                                {{getSampleDetailFromMap(row, col, 'sampleBarcode')}}
                                            </div>
                                            <div class="sampleInfo">
                                                {{getSampleDetailFromMap(row, col, 'orderNumber')}}
                                            </div>
                                            <div class="sampleInfo">
                                                {{getSampleDetailFromMap(row, col, 'sampleName')}}
                                            </div>
                                        </div>
                                        <div class="col-4 p-0">
                                            <label *ngIf="getSampleDetailFromMap(row, col, 'gxp')" class="gxplabel font-weight-bold text-danger mb-0" style="margin-top:21%;">GxP</label>
                                        </div>
                                    </div>

                                </button>
                                <p-overlayPanel [style]="{'width':'20rem', 'background-color':'whitesmoke'}" #stepCommentOverlay appendTo="body"  [baseZIndex]="10000000">
                                    <ng-template pTemplate>
                                        <div class="row">
                                            <div class="ui-inputgroup ml-2">
                                                <textarea style="width: 15rem;" [(ngModel)]="commentStr" placeholder="Add Plate Sample Comment"></textarea>
                                                <button pButton label="Save" (click)="saveCommentForSample(row, col, stepCommentOverlay)" [disabled]="commentSaveDisabled()"></button>
                                            </div>
                                        </div>
                                        <div class="row p-1 m-1 sample-comment">
                                            <div class="col-12 flex p-0">
                                                <label><b>Sample Comment: </b></label>
                                            </div>
                                            <div class="col-12 flex p-0">
                                                <p [innerHTML]="getPlateSampleComment(row, col)"></p>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-overlayPanel>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="col-12 flex p-0">
                    <div class="col-12 flex p-0">
                        <div *ngIf="!removeOperationStarted" class="col-6 p-0 text-left">
                            <button pButton class="action-button-table remove-start-button" label="Start Removal" (click)="onRemoveButtonClick()" [disabled]="disableRemoveButton()"></button>
                        </div>
                        <div *ngIf="!removeOperationStarted" class="col-6 p-0 font-bold flex justify-content-end">
                            <button pButton class="action-button-table save-button" label="Save Batch" (click)="saveScan()" [disabled]="saveScanDisabled()"></button>
                        </div>
                        <div *ngIf="removeOperationStarted" class="col-6 p-0 text-left">
                            <button pButton class="action-button-table remove-cancel-button" label="Cancel Remove" (click)="cancelRemove()"></button>
                        </div>
                        <div *ngIf="removeOperationStarted" class="col-6 p-0 font-bold">
                            <button pButton class="action-button-table remove-confirm-button" label="Confirm Removal" (click)="removeSamples()" ></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--IMPRTNT DO NOT REMOVE-->
<p-dialog header="Reagents" [(visible)]="kitLotPopUpVisible" modal="true" [baseZIndex]="10000" [contentStyle]="{'max-height':'50vh', 'max-width':'45vw', 'width':'40vw','overflow-x':'hidden'}">
    <ng-container *ngFor="let kitLot of reagents; let i = index;">
        <div class="col-12 flex">
            <div class="ui-inputgroup col-9 flex h-2rem p-0">
                <button pButton class="labelButton label-button-width p-1" [label]="kitLot?.reagent"></button>
                <input pInputText class="border-noround" [(ngModel)]="kitLot.lot" />
            </div>
            <div class="col-4 p-0">
                <button pButton icon="fa fa-plus-circle" class="h-2rem border-round-right" (click)="addReagent(i, kitLot?.reagent)"></button>
            </div>
        </div>
    </ng-container>
    <p-footer >
        <button pButton icon="pi pi-check" class="h-2rem border-round" label="Save" (click)="saveReagents()"></button>
      </p-footer>
</p-dialog>

<p-blockUI [blocked]="blocked">
    <div >
      <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
    </div>
</p-blockUI>
